import { render } from "./MigrationConsentModal.vue?vue&type=template&id=5fb688bc"
import script from "./MigrationConsentModal.vue?vue&type=script&lang=js"
export * from "./MigrationConsentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__